import { Component, OnInit } from '@angular/core';
import { SportService } from '../services/sport.service';
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
export interface Market {
  sportName: string,
  matchName: string,
  matchStatus: string,
  date: string,
  teamA: string,
  teamB: string
}
const ELEMENT_DATA: Market[] = [
  {
    matchName: "SriLanka vs South Africa",
    sportName: "Cricket",
    matchStatus: "open",
    date: "Sep 2,2021 3:00 PM",
    teamA: "-500",
    teamB: "335"
  }
]
@Component({
  selector: 'app-report-market',
  templateUrl: './report-market.component.html',
  styleUrls: ['./report-market.component.scss']
})
export class ReportMarketComponent implements OnInit {
  displayedColumns: string[] = ['number', 'sport_name', 'match_name', 'event_name', 'liability'];
  exposureData: any;
  expoLength: any;
  dataSource: any;
  pageIndex: any = 1
  totalItems: any = [];
  totalRecordIndex: any = 0
  message: string;
  popData: boolean;
  expoRouteData: any;
  constructor( private router: Router,private sportService: SportService, private toastr: ToastrService) { }
  ngOnInit(): void {
    this.getExposureData()
  }

  back() {
    window.history.back();
  }

  getExposureData() {
    let data = {};
    this.sportService.getExposure(data).subscribe((res) => {
      if (res.status == true) {
        this.popData = true;
        this.exposureData = res.data;
        this.dataSource = res.data;
        this.expoLength = this.exposureData.length;
        this.totalRecordIndex = this.exposureData.length - 1
        this.totalItems = this.dataSource.splice(this.dataSource.length - 1);
        // this.dataSource.splice(this.dataSource.length - 1);

      } else {
        this.message = "No Record Found ....";
        this.popData = false;
        // this.toastr.error(res.msg, '', {
          // positionClass: 'toast-top-center',
        //   timeOut: 10000,
        // })
      }


    })
  }

  
  expoRoute( id){
    let data = {
      "event": "match",
      "filter": {
          "match_id":id.match_id
      },
      "projection": [
          "enable_fancy",
          "inplay",
          "is_created",
          "is_lock",
          "is_active",
          "match_date",
          "bet_count"
      ]
  }
  this.sportService.getExposureRoute(data).subscribe((res) => {
    this.expoRouteData = res.data;
    this.expoRouteData.manualInplay = res.data.inplay;
    let a3 = {...id, ...this.expoRouteData};
    localStorage.setItem('matchData', JSON.stringify(a3));
    this.router.navigate(['match-detail']);
  })
  }
}
